import React, { useState, useEffect } from "react";
import { Button, Table, Container, Spinner, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import style from "./Actividades.module.css";
import ActivityFormModal from "../../components/Modals/ActivityFormModal";
import { FaTrash, FaPen, FaPlus, FaEye } from "react-icons/fa6";
import Swal from 'sweetalert2';
import { getActivities, deleteActivity } from "../../utils/Data";

const Actividades = () => {
  const [actividades, setActividades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [activityIdToEdit, setActivityIdToEdit] = useState();

  const handleGetActivities = async () => {
    try {
      const activitiesList = await getActivities();
      setActividades(activitiesList);
    } catch (error) {
      console.error("Error al obtener las actividades:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetActivities();
  }, []);

  const handleShowEditModal = (activityId) => {
    setActivityIdToEdit(activityId);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    handleGetActivities();
  }

  const handleShowAddModal = () => {
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => setShowAddModal(false);

  const handleDeleteActivity = async (activityId) => {
    try {
      Swal.fire({
        title: "¿Desea borrar la actividad?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "Cancelar"
      }).then(async (result) => {
        if (result.isConfirmed) {
          await deleteActivity(activityId);
          Swal.fire({
            title: "¡Actividad eliminada!",
            icon: "success"
          });
          handleGetActivities();
        }
      });
    } catch (error) {
      console.error("Error al eliminar el documento:", error);
    }
  }

  return (
    <Container className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="titles">Lista de actividades</h1>
        <Button variant="dark" className={`${style.addActivityBtn} d-flex align-items-center primaryBtn`} onClick={handleShowAddModal}>
          <FaPlus size="1.2rem" /> Agregar actividad
        </Button>
      </div>

      {loading ? (
        <div className="text-center my-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      ) : actividades.length > 0 ? (
        <Table striped bordered hover responsive className="shadow-sm overflow-hidden">
          <thead>
            <tr>
              <th>Nombre de la actividad</th>
              <th>Alumnos inscriptos</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {actividades.map((actividad) => (
              <tr key={actividad.id}>
                <td>
                  <NavLink to={`/activityPage/${actividad.id}`} className={style.links}>
                    {actividad.nombre}
                  </NavLink>
                </td>
                <td>
                  {actividad.fechas[0]?.usuarios.length}
                </td>
                <td>
                  <Row>
                    <Col>
                      <Button variant="primary" size="sm">
                        <NavLink to={`/activityPage/${actividad.id}`} className={style.links}>
                          <FaEye color="#ffffff" />
                        </NavLink>
                      </Button>

                      <Button variant="warning" size="sm" onClick={() => handleShowEditModal(actividad.id)} className="mx-2">
                        <FaPen color="#ffffff" />
                      </Button>

                      <Button variant="danger" size="sm" onClick={() => { handleDeleteActivity(actividad.id) }}>
                        <FaTrash color="#ffffff" />
                      </Button>
                    </Col>
                  </Row>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className="text-center text-muted">No hay actividades disponibles.</p>
      )}
      <ActivityFormModal showModal={showEditModal} handleCloseModal={handleCloseEditModal} activityIdToEdit={activityIdToEdit} edit={true} />
      <ActivityFormModal showModal={showAddModal} handleCloseModal={handleCloseAddModal} edit={false} />
    </Container>
  );
};

export default Actividades;
